import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import PaginationBase from "components/Pagination";

import cls from './Pagination.module.scss';
import Input from "components/Input";
import Select from "components/Select";
import { useLocation } from "react-router";

const Pagination = ({ total, current, currentItems, perPage, totalItems, pageRangeDisplayed = 5, onChange, onPerPageChange }) => {
   const { t } = useTranslation();
   const location = useLocation();
   const defaultPerPage = location.pathname.endsWith('/ai-pairs-search') ? 5 : 10;


   const [inputValue, setInputValue] = useState(current || 1);

   const handleInputChange = (value) => {
      if (/^\d*$/.test(value)) {
         setInputValue(value);
      }
   }

   useEffect(() => {
      setInputValue(current);
   }, [current]);

   return (
      <div className={cls.pagination}>
         <span className={cls.paginationText}>{t('pagination_pages')}:</span>

         <strong className={cls.paginationCount}>{currentItems} {t('pagination_of')} {totalItems}</strong>

         <PaginationBase
            total={total}
            current={current || 1}
            pageRangeDisplayed={pageRangeDisplayed}
            onChange={current => onChange(current)}
         />

         <div>
            <form
               onSubmit={e => {
                  e.preventDefault();
                  onChange(Number(inputValue || 1));
               }}
            >
               <Input
                  type="text"
                  size="small"
                  className={cls.gotoInput}
                  value={inputValue}
                  onChange={value => handleInputChange(value)}
               />
            </form>
         </div>

         <div className={cls.perPageSelect}>
            <Select
               size="small"
               value={perPage || defaultPerPage}
               allowClear={false}
               options={
                  [
                     {
                        title: 5,
                        value: 5
                     },
                     {
                        title: 10,
                        value: 10
                     },
                     {
                        title: 20,
                        value: 20
                     },
                     {
                        title: 50,
                        value: 50
                     },
                     {
                        title: 100,
                        value: 100
                     }
                  ]
               }
               onChange={value => onPerPageChange(value)}
            />
         </div>
      </div>
   )
};

export default Pagination;